import React from 'react';
import classnames from 'classnames';
import { tierText } from '../hooks/useCustomer';
import styles from './DesktopBenefitsTable.module.scss';

export const DesktopBenefitsTable: React.FC<{ tier?: number }> = ({ tier }) => {
  return (
    <table className={styles.table} cellSpacing={8}>
      <thead>
        <tr>
          <td style={{ fontSize: '28px', textTransform: 'capitalize' }}>Hive Benefits</td>
          <td className={classnames({ [styles.active]: tier === 0 })}>{tierText(0)}</td>
          <td className={classnames({ [styles.active]: tier === 1 })}>{tierText(1)}</td>
          <td className={classnames({ [styles.active]: tier === 2 })}>{tierText(2)}</td>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>Free Shipping on all orders</td>
          <td className={classnames({ [styles.active]: tier === 0 })}>On orders $75+</td>
          <td className={classnames({ [styles.active]: tier === 1 })}>Yes!</td>
          <td className={classnames({ [styles.active]: tier === 2 })}>Yes!</td>
        </tr>
        <tr>
          <td>Double credits on all purchases</td>
          <td className={classnames({ [styles.active]: tier === 0 })}>-</td>
          <td className={classnames({ [styles.active]: tier === 1 })}>LiftWear only</td>
          <td className={classnames({ [styles.active]: tier === 2 })}>Yes!</td>
        </tr>
        <tr>
          <td>Birthday discount</td>
          <td className={classnames({ [styles.active]: tier === 0 })}>10%</td>
          <td className={classnames({ [styles.active]: tier === 1 })}>15%</td>
          <td className={classnames({ [styles.active]: tier === 2 })}>20%</td>
        </tr>
        <tr>
          <td>Early access to sales + discounts</td>
          <td className={classnames({ [styles.active]: tier === 0 })}>Yes!</td>
          <td className={classnames({ [styles.active]: tier === 1 })}>Yes!</td>
          <td className={classnames({ [styles.active]: tier === 2 })}>Yes!</td>
        </tr>
        <tr>
          <td>Early access to product releases</td>
          <td className={classnames({ [styles.active]: tier === 0 })}>-</td>
          <td className={classnames({ [styles.active]: tier === 1 })}>Yes!</td>
          <td className={classnames({ [styles.active]: tier === 2 })}>Yes!</td>
        </tr>
      </tbody>
    </table>
  );
};

export default DesktopBenefitsTable;
